import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import AddQuotationFormInTab from './info/AddQuotationFormInTab';
import VnButton from '@ui/components/VnButton';
import { saveOutline, trashOutline, printOutline, bookOutline } from 'ionicons/icons';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { createQuotationAsync, deleteQuotationByIdAsync, generateQuotationPdfAsync, getAllQuotationAmountsAsync, getAllQuotationStatusAsync, getAllShippingMethodsAsync, getQuotationByIdAsync, getQuotationPreviewAsync, updateQuotationAsync } from '@application/features/quotations/quotationThunk';
import QuotationTabsHelpers from './quotationHelpers';
import Select from 'react-select';
import { statusDropDownStyles } from '@ui/styles/status-dropdown-style';
import AmountCalculationTab from './amountCalculation';
import ModalPopup from '@ui/components/VnModal';
import QuotationPreview from './quotationPreview';
import { IonIcon } from '@ionic/react';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { getWorkOrderByIdAsync, updateModulePermissionsStatusAsync, updateWorkOrderStatusById } from '@application/features/workorders/workorderThunk';
import { WorkorderStatus } from '@application/common/enums/workorder-status';
import { QuotationStatus } from '@application/common/enums/quotation-status';
import { getDebtorByIdAsync } from '@application/features/debtors/debtorThunk';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { TabNotification } from '@ui/components/VnTabNotification';
import PersistentWarningMessage from '@ui/components/VnNotification/PersistantWarningMessage';
import PersistentInfoMessage from '@ui/components/VnNotification/PersistantInfoMessage';
import { VisserModule } from '@application/common/enums/visser-module';
import { clearUpdateModulePermissionStatus, resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { useAsyncDebounce } from '@application/common/hooks/use-async-debounce';
import NotesTab from './notes/NotesTab';
import { clearUnchangedQuotationDataNull, setSelectedWorkorderCalculationItemsList, setWorkOrderNumber } from '@application/features/quotations/quotationSlice';
import EmailEditorForm from '@ui/components/VnEmailEditor';
import { getEmailTemplateByNameAsync } from '@application/features/sendemail/sendemailThunk';
export default function QuotationView() {
    const [activeTab, setActiveTab] = useState('InfoTab');
    const [submitQuotations, setSubmitQuotations] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { QuotationsStatusDropdown, SelectedWorkorderCalculationsItemIdsList, ShippingMethods } = useAppSelector((state) => state.quotation);
    const { debtor } = useAppSelector((state) => state.debtors);
    const { moduleLocked, updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const { handleFieldChange, handleCalendarChange, validateForm, formData, setFormData, errors, infoTabErrorBorderColor, isInfoTabUnsaved, isNotesTabUnsaved, isInfoTabBold, isNotesTabBold } = QuotationTabsHelpers();
    const { id } = useParams();
    VnDocumentTitle('Visser Off-' + formData.quotationNumber.replace(/@@/g, ''));
    const [isPreviewQuotationVisible, setIsPreviewQuotationVisible] = useState(false);
    const [isQuotationDeleteConfirmationPopup, setQuotationDeleteConfirmationPopup] = useState(false);
    const [savedDebtor, setSavedDebtor] = useState('');
    const { workOrder } = useAppSelector((state) => state.workorder);
    const { UpdateQuotation, QuotationAmounts } = useAppSelector((state) => state.quotation);
    const [isAmountCalculationTabBold, setIsAmountCalculationTabBold] = useState(false);
    const [offerEmailTemplate, setOfferEmailTemplate] = useState('');
    useEffect(() => {
        dispatch(getAllQuotationStatusAsync());
        dispatch(getAllShippingMethodsAsync());
    }, []);
    useEffect(() => {
        if (id) {
            dispatch(getQuotationByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
            })
                .catch((error) => {
                console.error('Bad request.');
                navigate(`/admin/Quotation`);
            });
        }
    }, [id]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitQuotations) {
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                const triggeredErrors = validateForm();
                if (Object.values(triggeredErrors).every((error) => !error)) {
                    if (!id) {
                        dispatch(createQuotationAsync(formData))
                            .unwrap()
                            .then((res) => {
                            setFormData(res);
                            navigate(`/admin/QuotationTabs/${res.id}`);
                        })
                            .catch((error) => {
                            console.error('Bad request.');
                            navigate(`/admin/Quotation`);
                        });
                    }
                    else {
                        dispatch(updateQuotationAsync(formData))
                            .unwrap()
                            .then((res) => {
                            if (id) {
                                dispatch(getQuotationByIdAsync(parseInt(id)))
                                    .unwrap()
                                    .then((res) => {
                                    setFormData(res);
                                })
                                    .catch((error) => {
                                    console.error('Bad request.');
                                    navigate(`/admin/Quotation`);
                                });
                            }
                        })
                            .catch((error) => {
                            console.error('Bad request.');
                        });
                    }
                }
                setSubmitQuotations(false);
            }
            if (workOrder?.statusId == WorkorderStatus.Gefactureerd || workOrder?.statusId !== WorkorderStatus.Vervallen) {
                if (formData.statusId == QuotationStatus.Verzonden_naar_klant) {
                    dispatch(updateWorkOrderStatusById({
                        workOrderId: formData.workOrderId,
                        statusId: WorkorderStatus.Opdracht_door_klant
                    }));
                }
            }
        }
    };
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    const handleStatusDropdownChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            statusId: selectedOption.value
        }));
    };
    const handleQuotationDelete = () => {
        if (id && id != null) {
            dispatch(deleteQuotationByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/Quotation'))
                .catch((error) => {
                setQuotationDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelQuotationDeleteClicked = () => {
        setQuotationDeleteConfirmationPopup(false);
    };
    useEffect(() => {
        if (formData.workOrderId) {
            dispatch(getWorkOrderByIdAsync(formData.workOrderId));
            debtor ? setSavedDebtor(debtor.name) : setSavedDebtor('');
        }
    }, [debtor, submitQuotations]);
    useEffect(() => {
        if (formData.debtorId)
            dispatch(getDebtorByIdAsync(formData.debtorId));
    }, [formData.id, submitQuotations]);
    useEffect(() => {
        if (id && UpdateQuotation)
            setFormData((prevData) => ({
                ...prevData,
                statusId: UpdateQuotation?.statusId
            }));
    }, [id, UpdateQuotation]);
    /////////////////////----Module Lock Functionality-----------////////////////////////
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Offertes,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    const checkModulelockandTimeTriggerForFields = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            // Return false immediately to allow the user to continue working
            var result = false;
            // Call the debounced API function
            debouncedCheckModuleLockApiCall()
                .then((res) => {
                if (res.isModuleAlreadyLocked) {
                    // Notify the user if the module is locked
                    // setIsPersistantInfoCustomToasterOpen(res.isModuleAlreadyLocked);
                    dispatch(setModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
                else {
                    dispatch(unsetModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
            })
                .catch(() => {
                dispatch(unsetModuleLock());
                // Handle any errors if needed
            });
            return result; // Allow user to continue working immediately
        }
        return false;
    };
    const checkModuleLockApiCall = async () => {
        const moduleLockRequestData = {
            moduleId: VisserModule.Offertes,
            recordId: formData.id
        };
        return await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
    };
    const debouncedCheckModuleLockApiCall = useAsyncDebounce(checkModuleLockApiCall, parseInt(process.env.REACT_APP_DEBOUNCE_TIME_FOR_MODULE_LOCK_API));
    useEffect(() => {
        // Cleanup function that runs when the component unmounts
        return () => {
            dispatch(resetTimer());
            dispatch(unsetModuleLock());
            dispatch(clearUpdateModulePermissionStatus());
            dispatch(clearUnchangedQuotationDataNull());
        };
    }, [resetTimer]);
    useEffect(() => {
        dispatch(unsetModuleLock());
        // checkModulelock();
    }, []);
    const handleFieldChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleFieldChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleFieldChangeWrapperForText = async (fieldName, value) => {
        handleFieldChange(fieldName, value); // Call the original handleFieldChange
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        // if (moduleLockStatus == false) {
        //     handleFieldChange(fieldName, value); // Call the original handleFieldChange
        // }
    };
    const handleCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleAmountCalculationTabBold = (state) => {
        setIsAmountCalculationTabBold(state);
    };
    //---------------- send Email
    const [isQuotationSentAsEmailViewOpen, setIsQuotationSentAsEmailViewOpen] = useState(false);
    const [quotationDocument, setQuotationDocument] = useState(null);
    const handelQuotationSentAsEmailWithAttachmentPopup = () => {
        dispatch(getEmailTemplateByNameAsync('SendOfferTemplate'))
            .unwrap()
            .then((res) => {
            if (res.body) {
                const bodyOfEmail = res.body
                    .replace('[Omschrijving]', workOrder?.description ? workOrder?.description : '')
                    .replace('[werkcategorie]', workOrder?.workOrderCategory ? workOrder?.workOrderCategory : '');
                setOfferEmailTemplate(bodyOfEmail);
                setIsQuotationSentAsEmailViewOpen(true);
                setIsPreviewQuotationVisible(false);
            }
        })
            .catch((error) => { });
        dispatch(getAllQuotationAmountsAsync(parseInt(id)));
        dispatch(getQuotationPreviewAsync(parseInt(id)))
            .unwrap()
            .then((res) => {
            if (QuotationAmounts) {
                const total = QuotationAmounts.filter((x) => x.isAmountHidden == true).reduce((acc, quotationAmount) => {
                    if (quotationAmount.isAmountHidden) {
                        return acc + quotationAmount.quantity * quotationAmount.price;
                    }
                    return acc;
                }, 0);
                const materials = {
                    clientOrderNumber: res?.clientOrderNumber,
                    projectManagerFullName: res?.projectManagerFullName,
                    projectManagerId: res?.projectManagerId,
                    objectClientReference: res?.objectClientReference,
                    contactPerson: res?.contactPerson,
                    quotationNumber: res?.quotationNumber,
                    address: debtor?.address,
                    postalCode: debtor?.postalCode,
                    city: debtor?.city,
                    country: debtor?.country,
                    name: debtor?.name,
                    quotationDate: res?.quotationDate,
                    totalAmount: total,
                    quotationAmounts: QuotationAmounts,
                    debtorId: formData.debtorId
                };
                dispatch(generateQuotationPdfAsync(materials))
                    .unwrap()
                    .then((res) => {
                    setQuotationDocument('data:application/pdf;base64,' + res);
                });
            }
        })
            .catch((error) => {
            console.error('Bad request.');
        });
    };
    const handelQuotationSentAsEmailClose = () => {
        setIsQuotationSentAsEmailViewOpen(false);
        setIsPreviewQuotationVisible(true);
    };
    //---------------- send Email
    const handleEmailSendSuccessForQuotation = (value) => {
        if (value) {
            handelQuotationSentAsEmailClose();
            updateQuotationStatusAndDate();
            if (!formData.dateSent) {
                return;
            }
            dispatch(updateWorkOrderStatusById({
                workOrderId: formData.workOrderId,
                statusId: WorkorderStatus.Geoffreerd
            }))
                .unwrap()
                .then(() => { })
                .catch(() => { });
        }
    };
    const updateQuotationStatusAndDate = () => {
        const updatedFormData = {
            ...formData,
            dateSent: new Date(),
            statusId: formData.statusId == QuotationStatus.Opdracht ? formData.statusId : QuotationStatus.Verzonden_naar_klant
        };
        dispatch(updateQuotationAsync(updatedFormData))
            .unwrap()
            .then((res) => {
            dispatch(getQuotationByIdAsync(res.id))
                .unwrap()
                .then((res) => {
                setFormData(res);
            })
                .catch((error) => {
                console.error('Bad request.');
            });
        })
            .catch((error) => { });
    };
    const handleQuotationOnModuleLockReset = (value) => {
        if (value) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => !error)) {
                dispatch(updateQuotationAsync(formData));
            }
        }
    };
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const dataKey = searchParams.get('dataKey');
        if (dataKey) {
            const savedData = localStorage.getItem(dataKey);
            if (savedData) {
                const { workOrderId, workOrderNumber, calculations } = JSON.parse(savedData);
                // Dispatch necessary actions
                dispatch(setWorkOrderNumber({ label: workOrderNumber, value: workOrderId }));
                dispatch(setSelectedWorkorderCalculationItemsList(calculations));
                handleFieldChange("workOrderId", workOrderId);
                handleFieldChange("workorderNumber", workOrderNumber);
                // Cleanup storage
                localStorage.removeItem(dataKey);
            }
        }
    }, [dispatch, searchParams]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Offertes" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/Quotation', children: [_jsx("span", { children: _jsx(IonIcon, { icon: bookOutline, className: 'vn-breadcrum-icon' }) }), "Offertes"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formData.quotationNumber.replace(/@@/g, '') }), formData.id ? (_jsxs(_Fragment, { children: [_jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: savedDebtor }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: workOrder?.description })] })) : ('')] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', isDisabled: moduleLocked || (handleRolePermission(Permission.OFFERTE, PermissionType.Delete) && id ? false : true), customIconClassName: 'vn-action-button-icon', onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setQuotationDeleteConfirmationPopup(true);
                                                    }
                                                }, type: 'button' }), _jsx(VnButton, { icon: printOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon', onClick: (event) => {
                                                    event.preventDefault();
                                                    setIsPreviewQuotationVisible(true);
                                                }, isDisabled: moduleLocked || !handleRolePermission(Permission.OFFERTE, PermissionType.Create), type: 'button' }), formData.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitQuotations(true);
                                                }, type: 'submit', customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked || !handleRolePermission(Permission.OFFERTE, PermissionType.Update) })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitQuotations(true);
                                                }, type: 'submit', customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked || !handleRolePermission(Permission.OFFERTE, PermissionType.Create) }))] })] }), _jsx("div", { className: 'vn-Status-Container', children: _jsxs("div", { style: { display: 'flex' }, children: [_jsx("label", { className: 'vn-status-label', children: "Status:" }), _jsx(Select, { placeholder: 'Select werkorder', isSearchable: false, styles: statusDropDownStyles, value: QuotationsStatusDropdown?.find((option) => option.value === formData.statusId), options: QuotationsStatusDropdown, onChange: handleStatusDropdownChange })] }) }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                            ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(AddQuotationFormInTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, onFieldChangeWithoutWrapper: handleFieldChange }) }), _jsx(Tab, { eventKey: 'BedragCalculatieTab', title: 'Bedrag calculatie', tabClassName: `${isAmountCalculationTabBold ? 'has-data' : ''}
                            `, children: _jsx(AmountCalculationTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onFieldChangeWithoutWrapper: handleFieldChange, onCalendarChange: handleCalendarChangeWrapper, isAmountCalculationTabBold: handleAmountCalculationTabBold }) }), _jsx(Tab, { eventKey: 'NotitiesTab', title: TabNotification('Notities', false, isNotesTabUnsaved), tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formData, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, onFieldChangeWithoutWrapper: handleFieldChange }) })] })] }), _jsx(ModalPopup, { title: 'Offerte', content: _jsx(QuotationPreview, { onClose: () => setIsPreviewQuotationVisible(false), formData: formData, handelQuotationSentAsEmailWithAttachmentPopup: handelQuotationSentAsEmailWithAttachmentPopup, updateQuotationStatusAndDate: updateQuotationStatusAndDate }), onOpen: isPreviewQuotationVisible, onClose: () => setIsPreviewQuotationVisible(false), modalWidth: 'xl' }), _jsx(VnConfirmationModel, { title: 'Alle gegevens op de offerte tabbladen zal permanent worden verwijderd. Weet u zeker dat u de offerte wilt verwijderen?', onCancel: () => onCancelQuotationDeleteClicked(), onConfirm: () => handleQuotationDelete(), onOpen: isQuotationDeleteConfirmationPopup }), offerEmailTemplate && offerEmailTemplate.trim() !== '' && (_jsx(ModalPopup, { title: 'Verzend e-mail', content: _jsx(EmailEditorForm, { onClose: handelQuotationSentAsEmailClose, isAttachmentAdded: true, emailWithAttachmentDto: {
                                attachment: quotationDocument,
                                attachmentName: 'Offerte-' +
                                    formData.quotationNumber.replace(/@@/g, '') +
                                    '-' +
                                    String(new Date().getDate()).padStart(2, '0') +
                                    String(new Date().getMonth() + 1).padStart(2, '0') +
                                    new Date().getFullYear() +
                                    '.pdf',
                                to: formData.debtorEmail ?? '',
                                subject: 'Offerte ' + formData.quotationNumber.replace(/@@/g, '') + ' mbt ' + workOrder?.description,
                                emailBody: offerEmailTemplate ?? ''
                            }, OnEmailSend: handleEmailSendSuccessForQuotation }), onOpen: isQuotationSentAsEmailViewOpen, onClose: handelQuotationSentAsEmailClose, modalWidth: 'lg' }))] }), updateModulePermissionStatus && !moduleLocked ? (_jsx(PersistentWarningMessage, { recordId: formData.id, moduleId: VisserModule.Offertes, handleIsModuleLockReset: handleQuotationOnModuleLockReset })) : (''), moduleLocked ? _jsx(PersistentInfoMessage, { recordId: formData.id, moduleId: VisserModule.Offertes }) : ''] }));
}
